var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"jyf-parser",style:(_vm.selectable ? 'user-select: text; -webkit-user-select: text;' : ''),attrs:{"id":'rtf' + _vm.uid},domProps:{"innerHTML":_vm._s(_vm.processedHtml)}})
}
var staticRenderFns = []

export { render, staticRenderFns }